"use strict";

export default class ContactController {
  mail = {
    title: "",
    content: "",
    firstname: "",
    lastname: "",
    email: "",
  };
  submitted = false;

  /*@ngInject*/
  constructor($http, Auth) {
    this.isLoggedIn = Auth.isLoggedInSync;
    this.$http = $http;
    this.mailSent = false;
  }

  send(form) {
    var that = this;
    this.submitted = true;
    this.errors = false;
    this.mailSent = false;
    if (form.$valid) {
      this.$http
        .post("api/users/send-mail", this.mail)
        .then(() => {
          that.mailSent = true;
        })
        .catch((err) => {
          that.errors = true;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/contact/contact.controller.js